<div
  class="py-xs hover:bg-background-underground-2 px-md group/item flex cursor-pointer flex-nowrap items-center rounded-md"
  routerLinkActive="component-medium-semibold [&>span]:text-components-content-primary-darker bg-components-background-primary-lightest hover:bg-components-background-primary-lightest"
>
  <span
    class="text-content-secondary flex-1 overflow-hidden text-ellipsis whitespace-nowrap"
    [routerLink]="['.']"
    [queryParams]="{ idProduction: production().id }"
    >{{ production().nom }}</span
  >
  <app-chip [label]="production().ressources.length" size="badge" />
</div>
